<script>
  import { Doughnut, mixins } from 'vue-chartjs'
  const { reactiveProp } = mixins

  export default {
    extends: Doughnut,
    mixins: [reactiveProp],
    props: {
      chartData: {
        type: Object,
        default: function () {
          return { }
        },
      },
      options: {
        type: Object,
        default: function () {
          return { }
        },
      },
      selectedIndex: { type: Number, default: 0 },
      activeDomain: { type: Number, default: null },
      plainText:{type: Boolean, default: false},
      showLabel:{type: Boolean, default: true},
      withPercentage: {type: Boolean, default: false},
      valueWithPercentage: {type: Boolean, default: false},
      beforeDrawCallback: { type: Function, required: false, default: () => {} }
    },

    watch: {
      activeDomain (newValue, oldValue) {
        const thisChart = this.$data._chart
        const activeSegment = thisChart.data.datasets[0]._meta[thisChart.id].data[this.activeDomain]
        if (this.activeDomain !== null) {
          thisChart.updateHoverStyle([activeSegment], null, true)
          thisChart.active = [thisChart.getDatasetMeta(0).data[this.activeDomain]]
        } else {
          thisChart.updateHoverStyle([thisChart.data.datasets[0]._meta[thisChart.id].data[oldValue]], null, false)
          thisChart.active = [thisChart.getDatasetMeta(0).data[this.selectedIndex]]
        }
        thisChart.render()
      },
    },
    mounted () {
      let THIS = this;
      this.addPlugin({
        beforeDraw: function (chart) {
          if (chart.canvas.id === 'doughnut-chart') {
            const width = chart.chart.width
            const height = chart.chart.height
            const ctx = chart.chart.ctx

            ctx.restore()
            ctx.font = '22px Roboto'
            ctx.textBaseline = 'middle'

            const index = chart.active !== undefined && chart.active.length !== 0 ? chart.active[0]._index : THIS.selectedIndex
            // top line
            const data = chart.data.datasets[0].data[index] || 0
            let text;
            if(THIS.withPercentage == true){
              if(THIS.valueWithPercentage)
                text = `${data || 0}%`
              else
              text = `${(Math.round(data * 10)) / 10 || 0}%`
            }
            else if(THIS.withPercentage == false){
              text = ((Math.round(data * 10)) / 10 || 0).toLocaleString()
            }

            if(THIS.plainText){
              text = `${(Math.round(data * 10)) / 10 || 0}`
              ctx.font = '40px Montserrat'
            }

            // Value of showLabel is true by default.
            // Therefore to hide a text in the chart send showLabel prop value as false 
            if (THIS.showLabel) {
              const textX = Math.round((width - ctx.measureText(text).width) / 2)
              const textY = height / 2 - 12.5
              ctx.fillText(text, textX, textY)
            }
            // bottom line
            ctx.font = '13px Roboto'

            ctx.textBaseline = 'middle'
            const label = chart.data.labels[index] || chart.data.labels[0] || ''
            const labelX = Math.round((width - ctx.measureText(label).width) / 2)
            const labelY = height / 2 + 12.5
            ctx.fillText(label, labelX, labelY)

           // Before drawer Callback
            THIS.beforeDrawCallback(chart);

            ctx.save()
          }
        },
      })
      this.renderChart(
        this.chartData,
        this.options
      )
    },
  }
</script>